/*
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let unsupported;
if (typeof navigator !== 'undefined' && 'deviceMemory' in navigator) {
    unsupported = false;
}
else {
    unsupported = true;
}
let memoryStatus;
if (!unsupported) {
    // The ts-ignores are needed because even with the compat checks TS complains
    // @ts-ignore
    const performanceMemory = 'memory' in performance ? performance.memory : null;
    memoryStatus = {
        unsupported,
        // @ts-ignore
        deviceMemory: 'deviceMemory' in navigator ? navigator.deviceMemory : null,
        totalJSHeapSize: performanceMemory
            ? // @ts-ignore
                performanceMemory.totalJSHeapSize
            : null,
        // @ts-ignore
        usedJSHeapSize: performanceMemory ? performanceMemory.usedJSHeapSize : null,
        jsHeapSizeLimit: performanceMemory
            ? // @ts-ignore
                performanceMemory.jsHeapSizeLimit
            : null,
    };
}
else {
    memoryStatus = { unsupported };
}
const useMemoryStatus = (initialMemoryStatus) => {
    return unsupported && initialMemoryStatus
        ? { ...memoryStatus, ...initialMemoryStatus }
        : { ...memoryStatus };
};

export { useMemoryStatus };
//# sourceMappingURL=index.js.map
